import PropTypes from 'prop-types';
import { useEffect, useState } from "react";
import { API_DOMAIN } from "../../config/env";
import { toast } from "../../helpers/message-helper";
import { Row, Col, Card, CardBody } from "reactstrap";
import { selectSedes } from "../../../modules/Sedes/services/sedes-service";

const SEDE_CARD_STYLE = {
    verticalAlign: "middle",
    WebkitTransform: "perspective(1px) translateZ(0)",
    transform: "perspective(1px) translateZ(0)",
    boxShadow: "0 0 1px rgb(0 0 0 / 0%)",
    WebkitTransitionDuration: "0.3s",
    transitionDuration: "0.3s",
    WebkitTransitionProperty: "transform",
    transitionProperty: "transform",
    cursor: "pointer",
    margin: "10px",
    width: "100%",
    minHeight: "120px",
};

const SeleccionSede = ({ onClickSede, parametrosBusquedaSedes }) => {
    const [sedes, setSedes] = useState([]);

    useEffect(async () => {
        const resp = await selectSedes(parametrosBusquedaSedes);
        if (!resp.status) return toast.error(resp.message);
        setSedes(resp.data);
    }, []);

    function clickSede(sede) {
        onClickSede(sede);
    }

    return (
        <Row>
            {sedes.map(function (sede) {
                return (
                    <Col md="4" className="mb-4" key={sede.id}>
                        <Card
                            style={SEDE_CARD_STYLE}
                            className="border-left-primary shadow h-100 hvr-grow"
                            onClick={() => clickSede(sede)}
                        >
                            <CardBody>
                                <div className="row">
                                    <div className="col-8 d-flex align-items-center flex-column">
                                        <p className="h4 font-weight-bold text-primary text-uppercase mb-2 text-left">
                                            {sede.sigla}
                                        </p>
                                        <p className="h5 font-weight-bold text-primary text-uppercase mb-2 text-left">
                                            {sede.direccion}
                                        </p>
                                        {sede.telefono && (
                                            <p className="h6 font-weight-bold text-primary text-uppercase mb-2 text-left">
                                                <i className="fas fa-phone"></i>
                                                {sede.telefono}
                                            </p>
                                        )}
                                    </div>
                                    <div className="col-4">
                                        <img
                                            className="rounded-circle"
                                            width="80"
                                            height="80"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src =
                                                    "img/logo_csr_big.png";
                                            }}
                                            alt={`Foto sede ${sede.sigla}`}
                                            src={`${API_DOMAIN}${sede.img}`}
                                        />
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
};

SeleccionSede.propTypes = {
    onClickSede: PropTypes.func,
    parametrosBusquedaSedes: PropTypes.object
}

export default SeleccionSede;
